module.exports = __webpack_public_path__ + "media/images/red-loader-1e6025a32ea1a669d4c7fb4d9f06b97b.gif";